exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-popover .el-tabs--border-card>.el-tabs__content{max-height:300px;overflow:auto}", ""]);

// exports
